(function () {
  function initialize(root) {
    if (root.dataset.lrFiestasReady === 'true') return;
    root.dataset.lrFiestasReady = 'true';
    root.querySelectorAll('[data-fiestas-menu-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var menu = root.querySelector('[data-menu="' + link.dataset.fiestasMenuLink + '"]');
        if (!menu) return;
        event.preventDefault();
        menu.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    });
  }
  document.querySelectorAll('[data-lr-fiestas]').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-lr-fiestas]').forEach(initialize);
  });
})();
